import TitleRoundedIcon from '@mui/icons-material/TitleRounded';
import CalendarTodayRoundedIcon from '@mui/icons-material/CalendarTodayRounded';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import type { CustomFieldFieldType } from 'services/custom-fields/schemas';

export interface FieldTypeOption {
  value: CustomFieldFieldType;
  labelKey: string;
  Icon: ComponentType<SvgIconProps>;
  placeholderHintKey: string;
  defaultPlaceholderKey: string;
}

export const FIELD_TYPE_OPTIONS = [
  {
    value: 'text' as const,
    labelKey: 'settings.legacy.custom_fields.create_dialog.text_input',
    Icon: TitleRoundedIcon,
    placeholderHintKey: 'settings.legacy.custom_fields.create_dialog.placeholder_text_placeholder',
    defaultPlaceholderKey: 'editor.variables.enter_a_value',
  },
  {
    value: 'date' as const,
    labelKey: 'settings.legacy.custom_fields.create_dialog.date_picker',
    Icon: CalendarTodayRoundedIcon,
    placeholderHintKey: 'settings.legacy.custom_fields.create_dialog.placeholder_text_placeholder',
    defaultPlaceholderKey: 'settings.legacy.custom_fields.create_dialog.date_picker_placeholder',
  },
  {
    value: 'dropdown' as const,
    labelKey: 'settings.legacy.custom_fields.create_dialog.dropdown',
    Icon: ArrowDropDownCircleIcon,
    placeholderHintKey: 'settings.legacy.custom_fields.create_dialog.placeholder_text_placeholder',
    defaultPlaceholderKey: 'settings.legacy.custom_fields.create_dialog.dropdown_placeholder',
  },
] satisfies FieldTypeOption[];

export const FIELD_TYPE_OPTIONS_MAP = new Map(FIELD_TYPE_OPTIONS.map((opt) => [opt.value, opt]));

export function getFieldTypeOption(type: CustomFieldFieldType): FieldTypeOption {
  return FIELD_TYPE_OPTIONS_MAP.get(type) as FieldTypeOption;
}
